/**
 * Resume and pause: the app's state in the shells, the page's visibility on the web. The clock
 * resyncs and the connection checks itself on resume.
 */
import { App } from '@capacitor/app';

import { isNative } from './env';

export type LifecycleListener = (active: boolean) => void;

export function onLifecycle(listener: LifecycleListener): () => void {
  if (isNative) {
    const handle = App.addListener('appStateChange', ({ isActive }) => {
      listener(isActive);
    });
    return () => {
      handle.then((h) => h.remove()).catch(() => undefined);
    };
  }
  const onVisibility = (): void => {
    listener(!document.hidden);
  };
  document.addEventListener('visibilitychange', onVisibility);
  return () => {
    document.removeEventListener('visibilitychange', onVisibility);
  };
}
